module.exports = "<p>\n  error404 works!\n</p>\n"